;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.masthead = (function () {
    const initialize = function () {
      const $trigger = $('.offer__trigger')
      $trigger.on('click', function () {
        $trigger.toggleClass('is-open')
        return false
      })
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.masthead.initialize()
  })
}(jQuery, window))
